<nav aria-label="breadcrumb">
	<ol class="breadcrumb" fxLayout="row wrap" fxLayoutAlign="start end">
		<li
			class="breadcrumb-item"
			fxFlex
			*ngFor="let step of steps; index as i"
			(click)="onSelectStep(step, i)"
			[ngClass]="{
				active: i === selectedStepIndex,
				completed: i < selectedStepIndex,
				'sub-step': step.isSubStep,
				unavailable:
					(!canAccessNextStep && i > selectedStepIndex) ||
					(!allowSelectAnyStep && i >= selectedStepIndex + 2),
				'cant-rewind-to': !revertableStepKeys.includes(step.key)
			}"
			[attr.aria-current]="selectedStep.key === step.key ? 'page' : null"
		>
			<div class="breadcrumb-label" [ngClass]="{ 'sub-step': step.isSubStep }">{{
				step.breadcrumbLabel
			}}</div>
			@if (step) {
				<div class="breadcrumb-bar"></div>
			}
		</li>
	</ol>
</nav>
